import * as angular from "angular";
import { IssueDataProvider } from "../../data-provider/issue.dp";
import { SurveyDataProvider } from "../../data-provider/survey.dp";
import { ToastUtils } from "../../helper/toast.helper";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { User } from "../../models/user.model";
import { UserDataProvider } from "../../data-provider/user.dp";
import { Campaign } from "../../models/campaign.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { ScreenUtils } from "../../helper/screen.helper";
import { canvassStatusConstants } from "../../utils/constants/canvass-status.constants";
import { DialogUtils } from "../../helper/dialog.helper";
import { PermissionCheck } from "../../shared/permission";
import { ApiUserService } from "../../services/user.service";

let WelcomeStepsComponent = {
    selector: "vcWelcomeSteps",
    templateUrl: "/angular/components/campaign/welcome-steps.component.html",
    bindings: {},
    controller: class WelcomeStepsController {
        // * bindings for typescript compiler *
        public campaign: Campaign;
        // ************************************

        public user: User;
        public page: number = 1;
        public isSaving: boolean = false;
        public userDetails: any = {};
        public phoneNumber: string;
        public campaignname: string;
        public campaignkind: string;
        public campaignKinds: any[] = [];
        public categoryId: number | null = null;
        public screen: any;
        public steps: number[] = [1, 2, 3, 4, 5];
        public statuses: any;

        private $window: any;
        private $scope: any;
        private __env: any;
        private $cookies: any;
        private toast: ToastUtils;
        private dialog: DialogUtils;

        private apiUserService: ApiUserService;
        private permissionProvider: PermissionCheck;
        private campaignDataProvider: CampaignDataProvider;
        private issueDataProvider: IssueDataProvider;
        private surveyDataProvider: SurveyDataProvider;
        private navigationBarHelperService: NavigationBarHelperService;

        constructor(
            $cookies: any,
            $scope: any,
            __env: any,
            IssueDataProvider: IssueDataProvider,
            SurveyDataProvider: SurveyDataProvider,
            UserDataProvider: UserDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            NavigationBarHelperService: NavigationBarHelperService,
            ScreenUtils: ScreenUtils,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils,
            PermissionCheck: PermissionCheck,
            ApiUserService: ApiUserService,
            $window: any,
            ModelsUtils: any
        ) {
            this.$cookies = $cookies;
            this.__env = __env;
            this.$scope = $scope;
            this.toast = ToastUtils;
            this.screen = ScreenUtils;
            this.$window = $window;
            this.dialog = DialogUtils;
            this.apiUserService = ApiUserService;

            this.permissionProvider = PermissionCheck;
            this.campaignDataProvider = CampaignDataProvider;
            this.issueDataProvider = IssueDataProvider;
            this.surveyDataProvider = SurveyDataProvider;
            this.navigationBarHelperService = NavigationBarHelperService;
            this.navigationBarHelperService.navigationBarHidden = true;

            this.user = ModelsUtils.user();
            this.user = UserDataProvider.getActiveUser();
            this.userDetails = {
                uid: this.user.uid,
                ufname: this.user.ufname,
                ulname: this.user.ulname,
                permissionid: this.user.permissionid,
                uemail: this.user.uemail,
            };

            this.campaignDataProvider.getKinds().then((kinds: any[]) => {
                this.campaignKinds = kinds;
            });

            this.campaign = this.campaignDataProvider.getActiveCampaign();

            this.$scope.$watch(
                () => this.page,
                () => {
                    if (this.page == 5) {
                        if (
                            this.categoryId != null &&
                            this.campaignKinds[this.categoryId].name ==
                                "Commercial Sales"
                        ) {
                            this.statuses = canvassStatusConstants.sales;
                        } else {
                            this.statuses = canvassStatusConstants.political;
                        }
                    } else {
                        this.statuses = null;
                    }
                }
            );
        }

        categoryClicked(id: number): void {
            this.categoryId = id;
            this.campaignkind = null;
        }

        next(): void {
            this.page += 1;
        }

        finishSetup(ev: object): void {
            if (!this.isSaving) {
                this.isSaving = true;

                this.apiUserService
                    .update(this.userDetails)
                    .then((response) => {
                        let json = response["data"];
                        if (json.success) {
                            this.user.setData(this.userDetails);
                            this.campaignDataProvider
                                .updateCampaign({
                                    campaignid: this.campaign.campaignid,
                                    phonenumber: this.phoneNumber,
                                    campaignname: this.campaignname,
                                    campaignkind:
                                        this.campaignkind["id"] ?? null,
                                })
                                .then((json) => {
                                    this.campaignDataProvider
                                        .createTailoredData({
                                            campaign_kind:
                                                this.campaignkind["id"] ?? null,
                                        })
                                        .then((json) => {
                                            this.$cookies.put("hideWelcome", 1);
                                            this.permissionProvider.featurePermissions =
                                                null;
                                            this.permissionProvider.allFeaturesPromise =
                                                null;

                                            this.campaign.campaignname =
                                                this.campaignname;
                                            this.campaignDataProvider.setActiveCampaign(
                                                this.campaign
                                            );
                                            this.issueDataProvider.clearAll();
                                            this.surveyDataProvider.clearAll();

                                            if (!json.success) {
                                                this.toast.error(
                                                    "Account update failed"
                                                );
                                            }
                                            this.permissionProvider
                                                .getFeaturePermissions()
                                                .then(() => {
                                                    this.permissionProvider.setBillingRight(
                                                        true
                                                    );
                                                    this.campaignDataProvider
                                                        .getOrganisations(true)
                                                        .then(() => {
                                                            if (
                                                                this.isIntercomUser()
                                                            ) {
                                                                this.campaignDataProvider.updateIntercomUser();
                                                            }

                                                            this.$window.location =
                                                                "#/";
                                                        });
                                                });
                                        });
                                });
                        }
                    });
            }
        }

        isIntercomUser(): boolean {
            return (
                this.permissionProvider.hasPermission("INTERCOM") &&
                !this.__env.test &&
                !this.adminEmail(this.user.uemail) &&
                !this.user.uemail.includes("markaokeeffe+")
            );
        }

        adminEmail(email: string): boolean {
            return (
                email &&
                (email.includes("@vconnecta") ||
                    email.includes("@civisconnect") ||
                    email.includes("@voxcitio") ||
                    email.includes("@ecanvasser"))
            );
        }

        openExplainCanvassStatusDialog(ev: object): void {
            this.dialog.show({
                component: "vc-explain-canvass-status",
                targetEvent: ev,
                scope: this.$scope,
                clickOutsideToClose: false,
                size: "x-large",
                locals: {},
                ariaLabel: "Explain Interaction Statuses",
            });
        }
    },
};

angular
    .module("campaign")
    .component(WelcomeStepsComponent.selector, WelcomeStepsComponent);
